<div class="dialog">
    <div class="dialog-title">
        <h6 class="pl-3">Update Stage <img src="assets/svg/close-white.svg" alt="close" (click)="close()"></h6>
    </div>
    <div class="content pt-0 px-0">
        <div class="row p-4 mb-4 details mx-0 pt-2">
            <div class="col-md-4">
                <label>Part</label>
                <div class="value">{{ batchDetails?.part_name || 'Core Mounting Plate' }}</div>
            </div>
            <div class="col-md-4">
                <label>Batch deadline</label>
                <div class="value">{{batchDetails?.dispatch_date || '18/03/2024' | date:'longDate'}}</div>
            </div>
            <div class="col-md-4">
                <label>Quantity</label>
                <div class="value">{{getStageQuantity()
                    ||'--'}}</div>
            </div>
        </div>

        <div class="container-fluid pt-0 row custom-form mb-4 mx-0">
            <div class="col">
                <label>Current Stage</label>
                <input type="text" disabled [value]="batchDetails?.current_stage?.name" placeholder=""
                    aria-label="Current stage">
            </div>
            <div class="col custom_select_form" [formGroup]="demoForm" validate>
                <label>Next Stage</label>
                <select class="select arrow-img" aria-label="Next stage" [disabled]="!batchDetails?.next_stages"
                    formControlName="next_stage">
                    <option *ngFor="let option of batchDetails?.next_stages" [value]="option?.id">{{option?.name}}
                    </option>
                </select>
            </div>
        </div>

        <div class="container-fluid pt-0 row custom-form mx-0">
            <div class="col px-2">
                <div class="upload-img-box">
                    <div [formGroup]="demoForm" validate>
                        <file-upload formControlName="files" accept=".jpg,.jpeg,.png,.svg,.pdf">
                            <ng-template let-isFileDragDropAvailable="isFileDragDropAvailable" #placeholder
                                let-control="control" #button>
                                <span *ngIf="isFileDragDropAvailable">
                                    <div _ngcontent-c1="" class="upload-input ng-trigger ng-trigger-zoomAnimation">
                                        <div _ngcontent-c1="" class="icon ng-tns-c1-2 ng-star-inserted">
                                            <svg _ngcontent-c1="" class="ng-tns-c1-2" viewBox="0 0 96 96">
                                                <g _ngcontent-c1="" class="ng-tns-c1-2">
                                                    <path _ngcontent-c1="" class="ng-tns-c1-2"
                                                        d="M62.8,68.1c0-0.6-0.2-1.1-0.6-1.5c-0.4-0.4-0.9-0.6-1.5-0.6s-1.1,0.2-1.5,0.6
                                             c-0.4,0.4-0.6,0.9-0.6,1.5c0,0.6,0.2,1.1,0.6,1.5c0.4,0.4,0.9,0.6,1.5,0.6s1.1-0.2,1.5-0.6S62.8,68.7,62.8,68.1z M71.3,68.1
                                             c0-0.6-0.2-1.1-0.6-1.5c-0.4-0.4-0.9-0.6-1.5-0.6c-0.6,0-1.1,0.2-1.5,0.6C67.2,67,67,67.5,67,68.1c0,0.6,0.2,1.1,0.6,1.5
                                             s0.9,0.6,1.5,0.6c0.6,0,1.1-0.2,1.5-0.6C71.1,69.2,71.3,68.7,71.3,68.1z M75.5,60.7v10.6c0,0.9-0.3,1.6-0.9,2.2
                                             c-0.6,0.6-1.4,0.9-2.2,0.9H23.7c-0.9,0-1.6-0.3-2.2-0.9c-0.6-0.6-0.9-1.4-0.9-2.2V60.7c0-0.9,0.3-1.6,0.9-2.2
                                             c0.6-0.6,1.4-0.9,2.2-0.9h14.1c0.5,1.2,1.2,2.2,2.3,3c1.1,0.8,2.3,1.2,3.7,1.2h8.5c1.3,0,2.6-0.4,3.7-1.2c1.1-0.8,1.9-1.8,2.3-3
                                             h14.1c0.9,0,1.6,0.3,2.2,0.9C75.2,59.1,75.5,59.8,75.5,60.7z M64.8,39.3c-0.4,0.9-1,1.3-2,1.3h-8.5v14.8c0,0.6-0.2,1.1-0.6,1.5
                                             c-0.4,0.4-0.9,0.6-1.5,0.6h-8.5c-0.6,0-1.1-0.2-1.5-0.6c-0.4-0.4-0.6-0.9-0.6-1.5V40.6h-8.5c-0.9,0-1.6-0.4-2-1.3
                                             c-0.4-0.9-0.2-1.6,0.5-2.3l14.8-14.8c0.4-0.4,0.9-0.6,1.5-0.6s1.1,0.2,1.5,0.6L64.3,37C65,37.7,65.1,38.4,64.8,39.3z">
                                                    </path>
                                                </g>
                                            </svg>
                                        </div>
                                        <div class="text-center">
                                            <img class="mb-2" src="assets/svg/upload-file.svg" alt="cube">
                                            <br>
                                        </div>
                                        <br>
                                        <div class="upload-text ng-tns-c1-2 ng-star-inserted text-center">
                                            <b class="center ng-tns-c1-2 ng-star-inserted ml-1">Attach files</b>
                                            <p class="mb-0 mt-2 drag-drop">
                                                (Max. file size 10 MB)</p>
                                        </div>
                                    </div>
                                </span>
                                <span *ngIf="!isFileDragDropAvailable">click</span>
                            </ng-template>
                        </file-upload>
                    </div>
                    <br>
                </div>
                <!-- <div class="uploaded-image" *ngIf="fileUploaded">
                    <img [src]="image_url" alt="">
                </div> -->
            </div>
        </div>
    </div>
    <div class="footer row container-fluid pr-0">
        <div class="col-md-6">

        </div>
        <div class="col-md-6 d-flex button">
            <button class="white mr-2" (click)="close()">Cancel</button>
            <button class="orange ml-2" (click)="updateStage()">Update Stage</button>
        </div>

    </div>
</div>